"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrudPattern = void 0;
var acorn_react_core_1 = require("@gcdtech/acorn-react-core");
var useCrudPattern = function (api) {
    var itemFetch = acorn_react_core_1.useFetch(api.read, { autoFetch: false, fetchDebounceLength: 200, suspenseDebounceLength: 1000 });
    var processor = acorn_react_core_1.useProcess();
    var currentlyFetching = '';
    var currentFetchPromise;
    return {
        item: itemFetch.item,
        itemFetchingState: itemFetch,
        itemProcessingState: processor,
        reset: itemFetch.reset,
        readItem: function (itemId) {
            if (currentlyFetching != itemId) {
                currentFetchPromise = itemFetch.fetch(itemId);
            }
            return currentFetchPromise;
        },
        createItem: function (item) {
            return processor.process(api.create, item);
        },
        updateItem: function (item) {
            return processor.process(api.update, item);
        },
        deleteItem: function (item) {
            return processor.process(api.destroy, item);
        },
    };
};
exports.useCrudPattern = useCrudPattern;
//# sourceMappingURL=useCrudPattern.js.map